<template>
    <section class="valuation-layout container" id="your-valuation">
        <h1 class="valuation-layout__header">Free Instant Vehicle Valuation</h1>
        <StepBar />
        <div v-if="authenticated && !extendedValuationCompleted && !valuationHasError" class="your-valuation__alert-container">
            <div class="your-valuation__alert your-valuation__alert--success">
                <span v-if="vehicleAdded && vehicleAddedMessage"> {{ vehicleAddedMessage }}</span>
                <span v-if="valuation"> You can view this vehicle's valuation in your account.</span>
            </div>
        </div>
        <div class="valuation-layout__container">
            <valuation-amount :show-cta="true"
                @show-book-now="bookNow()"
                :show-extended-valuation="showExtendedValuation"
                valuation-title="Your Estimated Vehicle Valuation"
                :valuation-text="valuationAmountText"
                failed-valuation-title="Thank you for valuing your vehicle."
                failed-valuation-text="Unfortunately we could not find a match for your registration. Please book an appointment below to visit your local Stellantis &You UK dealership where our expert team will appraise your vehicle."
            />

            <vehicle-image />

            <div class="your-valuation__booking-info">
                <div class="your-valuation__text" v-if="selectedDealer">When you bring your vehicle to {{ selectedDealer.name }} please bring:</div>
                <ul class="your-valuation__ul" >
                    <li>Drivers license or passport</li>
                    <li>Proof of address within the last 90 days</li>
                    <li>V5 document</li>
                    <li>All the relevant keys</li>
                    <li>Service & MOT history</li>
                    <li>Bank details</li>
                    <li>Car handbook</li>
                </ul>
            </div>
            <div class="valuation-layout__vehicle-details">
                <VehicleDetails :displayImage="false"/>
                <button v-if="step === 10 || !authenticated" @click="newValuation()" class="btn btn--full-width btn--primary-inverted">Start new valuation</button>
                <!-- <button v-if="!authenticated" @click="newValuation()" class="btn btn--full-width btn--primary-inverted">Start new valuation</button> -->
            </div>
            <div class="your-valuation__booking-details" id="booking-details" v-if="displayBookAppointment">
                <div id="bookNow" class="your-valuation__book-appointment rd-card rd-card--border-top" :class="{ 'your-valuation__book-appointment--margin-top' : authenticated  }">
                    <div class="your-valuation__book-appointment--top">
                        <div v-if="!bookingDetails">
                            <h3 class="title select-date-time__title">Book an Appointment</h3>
                            <p>You will receive a full vehicle check on site by one of our expert advisors. As this is an estimation, your valuation could increase dependant on the condition of your vehicle.</p>
                        </div>
                        <div v-else>
                            <h3 class="title select-date-time__title">Thank you for booking an appointment</h3>
                            <p>Please find your booking details below. A member of our team will be in contact shortly to confirm your appointment.</p>
                        </div>
                        <div class="your-valuation__dealer-info">
                            <h3 class="card__heading">Dealer Address</h3>
                            <p class="card__text">{{ selectedDealer.name }}
                                <br />
                                {{ selectedDealer.address }},
                                <br />
                                {{ selectedDealer.postcode }}
                            </p>
                        </div>
                    </div>

                    <select-date-time v-if="!bookingDetails" serviceType="sales"/>

                    <div v-else class="your-valuation__booking">
                        <h3 class="title select-date-time__title">Booking Details:</h3>
                        <div class="your-valuation__book-appointment--details">
                            <div class="your-valuation__book-appointment--row">
                                <span class="your-valuation__book-appointment--label">Date:</span>
                                <span class="your-valuation__book-appointment--value">{{ bookingDetailsFormatted.date }}</span>
                            </div>

                            <div class="your-valuation__book-appointment--row">
                                <span class="your-valuation__book-appointment--label">Time:</span>
                                <span class="your-valuation__book-appointment--value">{{ bookingDetailsFormatted.time}}</span>
                            </div>
                        </div>

                        <div class="your-valuation__book-appointment--button-container">
                            <a :href="selectedDealer.full_slug"  target="_blank" class="link  link--primary  link--has-icon">Discover Dealer</a>
                            <a :href="bookingDetails.directions_link" target="_blank" class="link link--secondary link--has-icon">Dealer Directions</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <button  v-if="!authenticated" @click="newValuation()" class="link link--secondary link--is-button link--has-icon your-valuation__start-new-auth">Start new valuation</button> -->
            <div v-if="step !== 10" class="valuation-layout__button-area  your-valuation__button-area">
                <a v-if="authenticated" href="/my-account" class="btn btn--primary-inverted  btn--full-width your-valuation__account-btn">
                    <span class="find-my-car__used-btn-txt">Visit My Account </span>
                </a>
                <!-- <button  v-if="authenticated" @click="newValuation()" class="link link--secondary link--is-button link--has-icon">Start new valuation</button> -->
                <button  v-if="authenticated" @click="newValuation()" class="btn btn--primary-inverted">Start new valuation</button>
            </div>


        </div>

        <div class="your-valuation__new-valuation">
            <create-account id="create-account" v-if="!authenticated"></create-account>
            <!-- <button v-if="step === 10" @click="newValuation()" class=" link link--secondary link--is-button link--has-icon">Start new valuation</button> -->
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { StepBar, SelectDateTime, VehicleDetails, ValuationAmount, CreateAccount, VehicleImage } from "../";

export default {
    components: {
        VehicleDetails,
        StepBar,
        SelectDateTime,
        ValuationAmount,
        VehicleImage,
        CreateAccount
    },
    props: {
        showExtendedValuation: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        }
    },
    methods: {
        ...mapActions('ValuationTool', ['newValuation', 'goToPosition', 'bookAppointment']),
        ...mapMutations('ValuationTool', ['setDisplayBookAppointment']),
        ...mapActions('ValuationExtended', ['goToBookAppointment']),

        bookNow(){
            this.goToBookAppointment();
            this.$nextTick(() => {
                this.goToPosition('bookNow');
            });
        }
    },
    computed: {
        ...mapState('ValuationTool', ['valuation', 'valuationHasError', 'bookingDetails', 'step', 'displayBookAppointment']),
        ...mapState('Auth', ['authenticated', 'vehicleAdded', 'vehicleAddedMessage']),
        ...mapState('Dealers', ['selectedDealer']),
        ...mapState('ValuationExtended', ['extendedValuationCompleted']),
        ...mapGetters('CustomerData', ['customerData']),
        ...mapGetters('ValuationTool', ['vehicleImage', 'bookingDetailsFormatted']),

        valuationAmountText() {
            if (this.step === 10) {
                return 'Thank you for completing a full valuation. When you bring your vehicle to your local Stellantis &You UK dealership one of our expert advisors will complete a full vehicle check to confirm your valuation estimate. You may want to adjust the deposit on your vehicle of interest with your valuation amount. '
            } else {
                return 'To receive an even more accurate vehicle valuation, please click below to provide more information on your vehicle service history and condition. If you would like to have your vehicle appraised at your local dealer, please click the appointment button below to book.'
            }
        }
    },
    mounted() {
        if (this.authenticated === true) {
            const userName = this.customerData.firstName;
            const myAccountSpan = document.getElementById('header-menu__my-account');
            if (myAccountSpan) {
                myAccountSpan.textContent = userName;
            }
        }
        if(this.displayBookAppointment === true){
            this.goToPosition('bookNow');
        }else{
            this.goToPosition('valuation-start')
            if(this.step === 4){
                this.setDisplayBookAppointment(true);
            }
        }
    },
}
</script>